import React, { useEffect } from "react";
import "../Css/About/AboutPage.css";
import HomeFacilites from "../Component/HomePage/HomeFacilities";
import HomeTestimonial from "../Component/HomePage/HomeTestimonial";
import aboutone from '../Images/thirteena.jpg'
import abouttwo from '../Images/abouttwo.jpg'
import Footer from "../Component/Footer/Footer";
import { MetaTags } from "react-meta-tags";
import twentythree from '../Images/twentythreea.jpg'
import { Slide, Zoom } from "react-awesome-reveal";
import { NavLink } from "react-router-dom";

const AboutPage = (() => {
     useEffect(()=>{
            window.scrollTo(0, 0);
        },[])
    return (
        <>
         <MetaTags>
                        <title>Top Resort In Neral | Seema Resort</title>
                        <meta title="Top Resort In Neral | Seema Resort" />
                        <meta name="description" content="Experience luxury and relaxation at Seema Resort, the Top Resort in Neral, offering scenic views, premium amenities, and exceptional hospitality." />
                        <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
                        <link rel="canonical" href="https://seemasresort.com/top-resort-neral" />
                        <meta http-equiv="cache-control" content="no-cache" />
                        <meta http-equiv="expires" content="0" />
                        <meta http-equiv="pragma" content="no-cache" />
                        <meta property="og:title" content=" Top Resort In Neral | Seema Resort" />
                        <meta property="og:locale" content="en_US" />
                        <meta property="og:type" content="website" />
                        <meta property="og:url" content="https://seemasresort.com/" />
                        <meta property="og:description" content="Experience luxury and relaxation at Seema Resort, the Top Resort in Neral, offering scenic views, premium amenities, and exceptional hospitality." />
                        <meta property="og:image" content="https://seemasresort.com/static/media/logo.png" />
                      </MetaTags>
            <section className="About-page-section-1">
                <h2 className='mt-5 ms-5' style={{color:'white'}}>About Us </h2>
            </section>

<div className="container mt-4 my-2 ">
<h1 className="text-start heading" style={{fontFamily:" var(---lato)"}}>Top Resort In Neral</h1>
</div>
            <section className="home-page-about-section">
                <div className="container">
                    <div className="home-page-about-section-main-con">
                        <div className="row">
                            <div className="col-md-6">
                                <Slide>
                                <div className="home-page-about-section-images-main-con">
                                    <div className="home-page-about-section-images-first">
                                        <img src={aboutone} alt="img"/>
                                    </div>
                                    <div className="home-page-about-section-images-second">
                                        <img src={abouttwo} alt="img"/>
                                    </div>
                                </div>
                                </Slide>
                            </div>
                            <div className="col-md-6">
                                <Slide direction="right">
                                <div className="home-page-about-section-details-main-con">
                                    <div className="home-page-about-section-details-con">
                                        <h2>HOTEL LUXURY</h2>
                                        <h3>Seema's Resort</h3>
                                        <p style={{textAlign:'justify'}}>Welcome to Seema Resort Top Resort In Neral, a tranquil escape nestled in the heart of Neral, where nature and luxury meet. Our resort offers an idyllic getaway from the hustle and bustle of city life, providing a peaceful retreat with world-class amenities. Whether you are looking for a relaxing vacation, an adventurous escape, or a memorable family gathering, Seema Resort promises an unforgettable experience.                                        </p>
                                        <p style={{textAlign:'justify'}}>At Seema Resort, we take pride in being recognised as the Top Resort In Neral. Our exceptional service, comfortable accommodations, and beautiful surroundings ensure that your stay with us is nothing short of extraordinary. From lush greenery to picturesque landscapes, our resort is designed to provide a serene atmosphere where you can unwind and rejuvenate.                                        </p>
                                        <div className="home-page-about-section-details-btn">
                                            <NavLink to="/family-resort-neral" style={{textDecoration:"none"}}>
                                            <button className="btn btn-lg btn-dark my-2 mb-4 d-flex" style={{
                                backgroundColor:"black",
                                borderRadius:"0"
                            }}>
                                                Connect Now
                                            </button>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                                </Slide>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="home-page-about-section p-0 mb-5" style={{backgroundColor:'#254222'}}>
                <div className="container-fluid p-5">
                    <div className="home-page-about-section-main-con">
                        <div className="row py-5">
                       <div className="col-12 col-md-7" style={{alignContent:"center"}}>
                        <Slide>
                                <div className="home-page-about-section-details-main-con">
                                    <div className="home-page-about-section-details-con">
                                       <p style={{textAlign:'justify',color:"#ece2b1"}}>Our range of spacious rooms and luxurious cottages offers the perfect blend of comfort and style. Each room is thoughtfully designed with modern amenities, ensuring that guests experience both relaxation and convenience. Whether you’re visiting for a weekend retreat, a corporate event, or a special occasion, we cater to all your needs with personalised services and attention to detail.                                       </p>
                                    </div>
                                </div>
                            
                                <div className="home-page-about-section-details-main-con">
                                    <div className="home-page-about-section-details-con">
                                       <p style={{textAlign:'justify',color:"#ece2b1"}}>Seema Resort is renowned for offering an exceptional dining experience. Our restaurant serves a variety of mouthwatering dishes, crafted from the freshest ingredients to satisfy your culinary cravings. We also offer a wide range of activities, including nature walks, indoor games, and more, ensuring that every guest has something exciting to enjoy.                                       </p>
                                    </div>
                                </div>
                           
                                <div className="home-page-about-section-details-main-con">
                                    <div className="home-page-about-section-details-con">
                                       <p style={{textAlign:'justify',color:"#ece2b1"}}>When it comes to choosing the Top Resort In Neral, Seema Resort stands out for its hospitality and charm. We believe in creating lasting memories for our guests, making each stay a unique and delightful experience. Join us for a peaceful retreat where nature, comfort, and exceptional service come together.                                       </p>
                                    </div>
                                </div>
                                </Slide>
                        </div>
                                <div className="col-12 col-md-5">
                                    <Zoom direction="out">
                                    <img src={twentythree} style={{width:'100%',height:"400px",
                                        objectFit:"cover",borderRadius:"12px"
                                    }} alt="img"/>
                                    </Zoom>
                                </div>
                        </div>
                    </div>
                </div>
            </section>
<HomeFacilites/>

            <HomeTestimonial/>
            <Footer/>
        </>
    )
});

export default AboutPage;